interface Links {
  qr: string;
  href: string;
  img: string;
}
export interface SolutionAppLinks {
  AppStore: Links;
  GooglePlay: Links;
}

export const SUPER_APP_LINKS: SolutionAppLinks = {
  AppStore: {
    qr: 'assets/images/qr_code_super_app_store.png',
    href: 'https://apps.apple.com/us/app/leafio-super-app/id6474915557',
    img: 'assets/images/badge_app_store.svg',
  },
  GooglePlay: {
    qr: 'assets/images/qr_code_super_google_play.png',
    href: 'https://play.google.com/store/apps/details?id=com.leafiomobileapp.production',
    img: 'assets/images/badge_google_play.svg',
  },
};
